// this file is: apps/pendolino/output/Restaumatic.Environment
import Device from "../../client/js/utils/Device.js";

// isMobileApp :: Effect Boolean
export function isMobileApp() {
  return Device.isMobileApp();
}

// getMobileAppTypeImpl :: Effect String
export function getMobileAppTypeImpl() {
  return Device.getMobileAppType();
};

// isInIframe :: Effect Boolean
export function isInIframe() {
  return Device.isInIframe();
}

// mobileGeolocationEnabled :: Effect Boolean
export function mobileGeolocationEnabled() {
  return Device.mobileGeolocationEnabled();
};
